import React from 'react'
import { Modal } from '@elamajs/ui-kit'

import { useMediaQuery } from '../../hooks'
import viborkaImage from './assets/viborka.png'
import periodImage from './assets/period.png'
import gearImage from './assets/gear.png'

import * as Styled from './MethodologyModal.styled'

type Props = {
  data: {
    period: string | React.ReactNode
    placement?: string | React.ReactNode
    analytics?: string | React.ReactNode
    description: string | React.ReactNode
  }
  isOpen: boolean
  onClose: () => void
}

const MethodologyModal: React.FC<Props> = ({ data, isOpen, onClose }) => {
  const displayType = useMediaQuery()

  const getModalWidth = () => {
    switch (displayType) {
      case 'large':
      case 'laptop':
      case 'tablet':
        return 500
      case 'mobile':
      default:
        return 290
    }
  }

  const modalWidth = getModalWidth()

  return (
    <Styled.Modal as={Modal} isOpened={isOpen} width={modalWidth} onRequestClose={onClose}>
      <Modal.Header>
        <Styled.ModalTitle>Описание методологии</Styled.ModalTitle>
      </Modal.Header>
      <Modal.Content>
        <Styled.Container>
          <Styled.Header>
            <Styled.Row>
              <Styled.Title isShort={!data.placement}>
                <img src={periodImage} width={18} height={18} alt="period" />
              </Styled.Title>
              <Styled.Description>{data.period}</Styled.Description>
            </Styled.Row>
            {data.placement && (
              <Styled.Row>
                <Styled.Title isShort={false}>
                  <img src={viborkaImage} width={18} height={18} alt="viborka" />
                </Styled.Title>
                <Styled.Description>{data.placement}</Styled.Description>
              </Styled.Row>
            )}
            {data.analytics && (
              <Styled.Row>
                <Styled.Title isShort={false}>
                  <img src={gearImage} width={18} height={18} alt="analytics" />
                </Styled.Title>
                <Styled.Description>{data.analytics}</Styled.Description>
              </Styled.Row>
            )}
          </Styled.Header>
          <Styled.Description>{data.description}</Styled.Description>
        </Styled.Container>
      </Modal.Content>
    </Styled.Modal>
  )
}

export default MethodologyModal
